import { DrillField } from '@/types'
import { randElement, randInt } from '@/common'

const letters = ['A', 'B', 'C', 'D', 'E', 'F', 'G']
const degrees = [2, 3, 4, 5, 6, 7, 9, 11, 13, 14]

interface LetterDegreesParams {
	Letters: Array<'A' | 'B' | 'C' | 'D' | 'E' | 'F' | 'G'>
	Degrees: Array<2 | 3 | 4 | 5 | 6 | 7 | 9 | 11 | 13 | 14>
	Direction: Array<'Up' | 'Down'>
}

(LetterDegrees as any).params = [
	{ title: 'Letters', options: letters },
	{ title: 'Degrees', options: degrees },
	{ title: 'Direction', options: ['Up', 'Down'] }
]

function LetterDegrees(params: LetterDegreesParams): DrillField[] {

	const deg = randElement(params.Degrees)
	const dir = randElement(params.Direction)
	let bottom = randElement(params.Letters)
	let top = letters[(letters.indexOf(bottom) + deg - 1) % letters.length]

	if(dir === 'Down') { [top, bottom] = [bottom, top] }

	return [
		{
			label: 'Question',
			value: `${bottom} ${dir} ${deg}`
		},
		{
			label: 'Answer',
			value: top,
			hide: true
		}
	]
}

export { LetterDegrees }
